import { Typography } from '@mui/material';

export const AppVersion = () => {
  return (
    <Typography variant={'caption'} color={'textSecondary'} align={'center'} fontSize={8}>
      v{import.meta.env.PACKAGE_VERSION}
    </Typography>
  );
};
